import useList from '../_basic/list';
import useItem from '../_basic/item';
import schemas from './list.graphql';
import itemSchema from './item.graphql';
import provider from '@/api/apollo-client';

export default function(filters) {
  const object = new useItem(itemSchema);
  const datasets = new useList(schemas, filters);

  return {
    datasets,
    object: {
      ...object,
      linkObjectToObject: data => {
        return provider.mutate({
          mutation: itemSchema.connectObjectsToObject,
          variables: {
            input: data
          }
        });
      },
      unlinkObjectToObject: data => {
        return provider.mutate({
          mutation: itemSchema.disconnectObjectsToObject,
          variables: {
            input: data
          }
        });
      },
      updateObjectProperty: data => {
        return provider.mutate({
          mutation: itemSchema.updateObjectProperty,
          variables: {
            input: data
          }
        });
      },
      updateObjectProperties: data => {
        return provider.mutate({
          mutation: itemSchema.updateObjectProperties,
          variables: {
            input: data
          }
        });
      },
      updateObjectPropertiesNoCache: data => {
        return provider.mutate({
          mutation: itemSchema.updateObjectProperties,
          variables: {
            input: data
          },
          fetchPolicy: 'no-cache'
        });
      },
      createControlsExecution: data => {
        return provider.mutate({
          mutation: itemSchema.createControlsExecution,
          variables: {
            input: data
          }
        });
      },
      muteObject: data => {
        return provider.mutate({
          mutation: itemSchema.muteObject,
          variables: {
            input: data
          }
        });
      },
      addToFavorite: data => {
        return provider.mutate({
          mutation: itemSchema.addToFavorite,
          variables: {
            input: data
          }
        });
      },
      getHistoryControls: data => {
        return provider.query({
          query: itemSchema.getControls,
          variables: {
            ...data
          },
          fetchPolicy: 'no-cache'
        });
      },
      getPropertiesHistory: data => {
        return provider.query({
          query: itemSchema.getPropertiesHistory,
          variables: {
            ...data
          },
          fetchPolicy: 'no-cache'
        });
      },
      subscribeObject: data => {
        return provider.subscribe({
          variables: data,
          query: itemSchema.subscribeObject
        });
      },
      getObjectProperty: id => {
        return provider.query({
          variables: {
            id
          },
          query: itemSchema.getObjectProperty
        });
      },
      getControlExecution: data => {
        return provider.query({
          variables: data,
          query: itemSchema.getControlExecutions
        });
      },
      getReportsForControlExecution: data => {
        return provider.query({
          variables: data,
          query: itemSchema.getReportsForControlExecution,
          fetchPolicy: 'no-cache'
        });
      }
    }
  };
}
